import _1w0qswdat2 from '../dictionary/courses-page.json' with { type: 'json' };
import _f3rxxinpdz from '../dictionary/courses-section.json' with { type: 'json' };
import _2aycd95m94d from '../dictionary/cta-section.json' with { type: 'json' };
import _1zywhuwuro9 from '../dictionary/footer.json' with { type: 'json' };
import _19cm52egjad from '../dictionary/header.json' with { type: 'json' };
import _zdgqhyc8w0 from '../dictionary/hero-section.json' with { type: 'json' };
import _u8mkwjmw1a from '../dictionary/marquee-section.json' with { type: 'json' };
import _22uafh8sjxm from '../dictionary/service-worker.json' with { type: 'json' };
import _qwhizdmfgm from '../dictionary/status.json' with { type: 'json' };
import _2a2mqdu2zf7 from '../dictionary/why-section.json' with { type: 'json' };

const dictionaries = {
  "courses-page": _1w0qswdat2,
  "courses-section": _f3rxxinpdz,
  "cta-section": _2aycd95m94d,
  "footer": _1zywhuwuro9,
  "header": _19cm52egjad,
  "hero-section": _zdgqhyc8w0,
  "marquee-section": _u8mkwjmw1a,
  "service-worker": _22uafh8sjxm,
  "status": _qwhizdmfgm,
  "why-section": _2a2mqdu2zf7
};
const getDictionaries = () => dictionaries;

export { getDictionaries };
export default dictionaries;
